/*
With pure css it is hard to reuse classes because there is no way of composing a class of several subclasses. 
This is possible with a css post processor but they make it impractical to see in the browser from which class (composite and subclass) a specific style came.
Css postprocessing also introduces another programming language with its own syntax.
Below is an attempt to compose a class from subclasses using plain javascript string concatenation.
//*/

import menuStyles from "../MainScreen/Menu.module.css";
import menuExistingItemStyles from "../MainScreen/MenuExistingItemStyles.module.css";
import assetInspectorStyles from "../MainScreen/SelectedAssetInspector.module.css";
import showHideStyles from "../styles/ShowHide.module.css";

import buttonStyles from "./Buttons.module.css";

const c = (arr: string[]) => arr.join(" ");

/* 
! READ THIS ! 
Show hide styles is added to each super class to make color and background color animation work.
color and background color where originally added to everything within a form in Forms.module.css, but this collided with the css on showHide module.
I therefore added the color and background color to the ShowAnimate css class and added that class to all superclasses.
This might not be the best solution, but is pragmatic for now.
//*/

export const buttonRibbonStyle = c([
  `buttonRibbonStyle`,
  showHideStyles.ShowAnimate,
  menuStyles.ListItem,
  buttonStyles.ButtonRibbon,
]);
export const listItemInput = c([
  `listItemInput`,
  showHideStyles.ShowAnimate,
  menuStyles.ListItem,
  menuStyles.ListInputItem,
]);
export const menuExistingItemCard = c([
  `menuExistingItemCard`,
  showHideStyles.ShowAnimate,
  menuStyles.ListItem,
  menuExistingItemStyles.ListItem,
  menuStyles.List,
  menuExistingItemStyles.List,
]);
export const menuExistingItemCardRow = c([
  `menuExistingItemCardRow`,
  showHideStyles.ShowAnimate,
  menuStyles.ListItem,
  menuExistingItemStyles.Row,
]);
export const rightSideMenuHeader = c([
  `rightSideMenuHeader`,
  showHideStyles.ShowAnimate,
  menuStyles.ListItem,
  menuStyles.ListItemNoPadding,
  assetInspectorStyles.AssetHeaderAlign,
]);
